import {Component} from '@angular/core';
import {TabsPageContainer} from '../../../uiComponents/tabsPageContainer';

@Component({
	selector: 'email-flow-tabs',
	templateUrl: './email-flow-tabs.component.html',
})
export class EmailFlowTabsComponent extends TabsPageContainer {
	tabWidth = 180;
}
